const sbjs = require('sourcebuster')

sbjs.init()
